import React from "react";
import "../Sidebar/Sidebar.css";
import { useNavigate } from "react-router-dom";
import LogoMain from "assets/img/Logo_AcquaMonitoring.svg";
import Box from "assets/png/box.png";
import Menu from "assets/png/menu.png";
import Settings from "assets/png/settings.png";
import RoundUser from "assets/png/round-user.png";

export default function Techbar() {
  const nav = useNavigate();
  const user_params_id = localStorage.getItem("user_params_id");
  const loggedUser = JSON.parse(localStorage.getItem("loggedUser"));

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user_params_id");
    localStorage.removeItem("loggedUser");
    localStorage.removeItem("user_role_id");
    localStorage.removeItem("oldtoken");
  
    // Supprimer les cookies si applicable
    document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    
    window.location.reload(); // Recharger la page
    nav("/");
  };

  function navigationDashboard() {
    nav("/Dashboard");
  }
  function navigationBoitier() {
    nav("/boitier");
  }
  function navigationClient() {
    nav("/userList/5");
  }
  function navigationUser() {
    nav(`/showUser/${user_params_id}`);
  }
  // function navigationReglages() {
  //   nav('/TechReglages');
  // }

  return (
    <div className="sidebar-custom">
      <div className="sidebar_logo_container">
        <img className="sidebar_logo" src={LogoMain} alt="logo sidebar"></img>
      </div>
      <div className="sidebar-header-custom">
        {loggedUser ? (
          <h1>
            {loggedUser.name} {loggedUser.firstname}
          </h1>
        ) : null}
      </div>
      <div
        style={{ borderTop: "0.5px solid #fff", marginBottom: "20px" }}
      ></div>
      <div className="sidebar-items">
        <div className="item-custom" onClick={navigationDashboard}>
          <img className="sidebar-icon" src={Menu} alt="temp"></img>
          <span className="sidebar-text">DASHBOARD</span>
        </div>
        <div className="item-custom" onClick={navigationBoitier}>
          <img className="sidebar-icon" src={Box} alt="temp"></img>
          <span className="sidebar-text">BOITIERS</span>
        </div>
        <div className="item-custom" onClick={navigationClient}>
          <img className="sidebar-icon" src={RoundUser} alt="temp"></img>
          <span className="sidebar-text">CLIENT</span>
        </div>
        <div className="item-custom" onClick={navigationUser}>
          <img className="sidebar-icon" src={RoundUser} alt="temp"></img>
          <span className="sidebar-text">PROFILE</span>
        </div>
        <div className="logout-button-sidebar-custom">
          <button className="logoutButton" type="submit" onClick={logout}>
            Deconnexion
          </button>
        </div>
      </div>
    </div>
  );
}
